import React from "react";
import { useSelfie } from "~/components/auth/Auth";
import Redirect from "~/lib/route/Redirect";
import NavbarLayout from "~/src/components/navbar/NavbarLayout";
import SignInPage from "~/src/components/auth/SignInPage";

export default function Index() {
  const user = useSelfie();

  if (user) {
    return <Redirect to="/" />;
  }

  return (
    <NavbarLayout pb={0} isLoggingIn={true}>
      <SignInPage signingIn={false} />
    </NavbarLayout>
  );
}
